import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TextareaComponent } from '../controls/textarea.component';
import { BaseFieldComponent } from './base-field.component';
import { FieldContainerComponent } from './field-container.component';

@Component({
  selector: 'app-textarea-field',
  imports: [CommonModule, FieldContainerComponent, TextareaComponent],
  template: `
    <app-field-container
      [label]="label"
      [labelClasses]="labelClasses"
      [valueClasses]="valueClasses"
      [control]="control"
    >
      <ng-template #value>
        <app-textarea
          [control]="control"
          [screenReaderLabel]="controlLabel || label"
          [placeholder]="placeholder"
          [helpText]="helpText"
        />
      </ng-template>
    </app-field-container>
  `,
  styles: ``,
})
export class TextareaFieldComponent extends BaseFieldComponent {}
